// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Fonts/Fira_Sans/FiraSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Fonts/Bahij Helvetica/Bahij Helvetica Neue-Roman.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #eeeeee; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #bdbdbd; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 540px) {

  .\\!container {
    max-width: 540px !important;
  }

  .container {
    max-width: 540px;
  }
}
@media (min-width: 720px) {

  .\\!container {
    max-width: 720px !important;
  }

  .container {
    max-width: 720px;
  }
}
@media (min-width: 960px) {

  .\\!container {
    max-width: 960px !important;
  }

  .container {
    max-width: 960px;
  }
}
@media (min-width: 1140px) {

  .\\!container {
    max-width: 1140px !important;
  }

  .container {
    max-width: 1140px;
  }
}
@media (min-width: 1320px) {

  .\\!container {
    max-width: 1320px !important;
  }

  .container {
    max-width: 1320px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.\\!invisible {
  visibility: hidden !important;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-left-1 {
  left: -0.25rem;
}
.-left-3\\.5 {
  left: -0.875rem;
}
.-left-4 {
  left: -1rem;
}
.-left-\\[22px\\] {
  left: -22px;
}
.-right-3\\.5 {
  right: -0.875rem;
}
.-right-4 {
  right: -1rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-1\\/4 {
  top: -25%;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-8 {
  top: -2rem;
}
.-top-\\[14px\\] {
  top: -14px;
}
.-top-\\[4\\.8rem\\] {
  top: -4.8rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-24 {
  bottom: 6rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-\\[14\\%\\] {
  bottom: 14%;
}
.bottom-\\[4\\%\\] {
  bottom: 4%;
}
.end-0 {
  inset-inline-end: 0px;
}
.end-12 {
  inset-inline-end: 3rem;
}
.end-4 {
  inset-inline-end: 1rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/4 {
  left: 25%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\/4 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[2\\%\\] {
  left: 2%;
}
.left-\\[max\\(50\\%\\2c 25rem\\)\\] {
  left: max(50%,25rem);
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-\\[14\\%\\] {
  right: 14%;
}
.right-\\[2\\%\\] {
  right: 2%;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.start-5 {
  inset-inline-start: 1.25rem;
}
.top-0 {
  top: 0px;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\/4 {
  top: 50%;
}
.top-24 {
  top: 6rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.top-\\[calc\\(50\\%-14px\\)\\] {
  top: calc(50% - 14px);
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[998\\] {
  z-index: 998;
}
.z-\\[9995\\] {
  z-index: 9995;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.m-0 {
  margin: 0px;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-8 {
  margin-left: -2rem;
  margin-right: -2rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-32 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2\\.5 {
  margin-left: -0.625rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-auto {
  margin-left: auto;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mr-12 {
  margin-right: 3rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[1\\.7rem\\] {
  margin-top: 1.7rem;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-1\\/4 {
  height: 25%;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[32rem\\] {
  height: 32rem;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[64rem\\] {
  height: 64rem;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-\\[calc\\(100vh-3rem\\)\\] {
  height: calc(100vh - 3rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100vh\\] {
  max-height: 100vh;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.max-h-\\[40px\\] {
  max-height: 40px;
}
.max-h-\\[48px\\] {
  max-height: 48px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(88vh-88px\\)\\] {
  max-height: calc(88vh - 88px);
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-11 {
  min-height: 2.75rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-28 {
  min-height: 7rem;
}
.min-h-64 {
  min-height: 16rem;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[12px\\] {
  min-height: 12px;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[44vh\\] {
  min-height: 44vh;
}
.min-h-\\[46px\\] {
  min-height: 46px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[50vh\\] {
  min-height: 50vh;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[75vh\\] {
  min-height: 75vh;
}
.min-h-\\[9rem\\] {
  min-height: 9rem;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[128rem\\] {
  width: 128rem;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[64rem\\] {
  width: 64rem;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-\\[100vw\\] {
  min-width: 100vw;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[48px\\] {
  min-width: 48px;
}
.min-w-\\[80\\%\\] {
  min-width: 80%;
}
.min-w-\\[90\\%\\] {
  min-width: 90%;
}
.min-w-\\[95\\%\\] {
  min-width: 95%;
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[1440px\\] {
  max-width: 1440px;
}
.max-w-\\[155px\\] {
  max-width: 155px;
}
.max-w-\\[32px\\] {
  max-width: 32px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[48px\\] {
  max-width: 48px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-\\[min\\(20rem\\2c calc\\(100vw-2rem\\)\\)\\] {
  max-width: min(20rem,calc(100vw - 2rem));
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-2xl {
  max-width: 1320px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.basis-full {
  flex-basis: 100%;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4 {
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-5 {
  --tw-translate-y: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.\\!resize-none {
  resize: none !important;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.\\!resize {
  resize: both !important;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-\\[1fr_auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[6rem_1fr\\] {
  grid-template-columns: 6rem 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-16 {
  row-gap: 4rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 179 0 / var(--tw-divide-opacity));
}
.divide-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(30 136 229 / var(--tw-divide-opacity));
}
.divide-blue-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-divide-opacity));
}
.divide-blue-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(84 110 122 / var(--tw-divide-opacity));
}
.divide-brown-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(109 76 65 / var(--tw-divide-opacity));
}
.divide-cyan-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-divide-opacity));
}
.divide-deep-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(244 81 30 / var(--tw-divide-opacity));
}
.divide-deep-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(94 53 177 / var(--tw-divide-opacity));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-divide-opacity));
}
.divide-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(117 117 117 / var(--tw-divide-opacity));
}
.divide-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(67 160 71 / var(--tw-divide-opacity));
}
.divide-indigo-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-divide-opacity));
}
.divide-light-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(3 155 229 / var(--tw-divide-opacity));
}
.divide-light-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(124 179 66 / var(--tw-divide-opacity));
}
.divide-lime-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-divide-opacity));
}
.divide-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(251 140 0 / var(--tw-divide-opacity));
}
.divide-pink-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(216 27 96 / var(--tw-divide-opacity));
}
.divide-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(142 36 170 / var(--tw-divide-opacity));
}
.divide-red-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 57 53 / var(--tw-divide-opacity));
}
.divide-teal-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 137 123 / var(--tw-divide-opacity));
}
.divide-yellow-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(253 216 53 / var(--tw-divide-opacity));
}
.self-start {
  align-self: flex-start;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-wrap {
  text-wrap: wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-s {
  border-inline-start-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-indigo-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 134 203 / var(--tw-border-opacity)) !important;
}
.\\!border-indigo-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(48 63 159 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#2AC465\\] {
  --tw-border-opacity: 1;
  border-color: rgb(42 196 101 / var(--tw-border-opacity));
}
.border-\\[\\#334155\\] {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.border-\\[\\#C9F6DD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(201 246 221 / var(--tw-border-opacity));
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 236 179 / var(--tw-border-opacity));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(255 224 130 / var(--tw-border-opacity));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-blue-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-blue-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.border-current {
  border-color: currentColor;
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.border-gray-300\\/20 {
  border-color: rgb(224 224 224 / 0.2);
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(197 202 233 / var(--tw-border-opacity));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(159 168 218 / var(--tw-border-opacity));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(121 134 203 / var(--tw-border-opacity));
}
.border-indigo-400\\/70 {
  border-color: rgb(92 107 192 / 0.7);
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-border-opacity));
}
.border-indigo-900\\/10 {
  border-color: rgb(26 35 126 / 0.1);
}
.border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 205 210 / var(--tw-border-opacity));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(239 154 154 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(211 47 47 / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.\\!border-t-transparent {
  border-top-color: transparent !important;
}
.border-b-blue-gray-100 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-b-gray-200 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-blue-gray-100 {
  --tw-border-opacity: 1;
  border-top-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-t-gray-200 {
  --tw-border-opacity: 1;
  border-top-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-t-gray-500\\/10 {
  border-top-color: rgb(158 158 158 / 0.1);
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-indigo-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(48 63 159 / var(--tw-bg-opacity)) !important;
}
.\\!bg-red-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(211 47 47 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#0F172A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.bg-\\[\\#128C7E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 140 126 / var(--tw-bg-opacity));
}
.bg-\\[\\#25D366\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity));
}
.bg-\\[\\#334780\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 71 128 / var(--tw-bg-opacity));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 236 179 / var(--tw-bg-opacity));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 225 / var(--tw-bg-opacity));
}
.bg-amber-50\\/70 {
  background-color: rgb(255 248 225 / 0.7);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10 {
  background-color: rgb(255 193 7 / 0.1);
}
.bg-amber-500\\/20 {
  background-color: rgb(255 193 7 / 0.2);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 222 251 / var(--tw-bg-opacity));
}
.bg-blue-50\\/70 {
  background-color: rgb(227 242 253 / 0.7);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10 {
  background-color: rgb(33 150 243 / 0.1);
}
.bg-blue-500\\/20 {
  background-color: rgb(33 150 243 / 0.2);
}
.bg-blue-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.bg-blue-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(176 190 197 / var(--tw-bg-opacity));
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.bg-blue-gray-50\\/50 {
  background-color: rgb(236 239 241 / 0.5);
}
.bg-blue-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.bg-blue-gray-500\\/10 {
  background-color: rgb(96 125 139 / 0.1);
}
.bg-blue-gray-500\\/20 {
  background-color: rgb(96 125 139 / 0.2);
}
.bg-brown-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.bg-brown-500\\/10 {
  background-color: rgb(121 85 72 / 0.1);
}
.bg-brown-500\\/20 {
  background-color: rgb(121 85 72 / 0.2);
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.bg-cyan-500\\/10 {
  background-color: rgb(0 188 212 / 0.1);
}
.bg-cyan-500\\/20 {
  background-color: rgb(0 188 212 / 0.2);
}
.bg-deep-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.bg-deep-orange-500\\/10 {
  background-color: rgb(255 87 34 / 0.1);
}
.bg-deep-orange-500\\/20 {
  background-color: rgb(255 87 34 / 0.2);
}
.bg-deep-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.bg-deep-purple-500\\/10 {
  background-color: rgb(103 58 183 / 0.1);
}
.bg-deep-purple-500\\/20 {
  background-color: rgb(103 58 183 / 0.2);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(189 189 189 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-gray-50\\/50 {
  background-color: rgb(250 250 250 / 0.5);
}
.bg-gray-50\\/80 {
  background-color: rgb(250 250 250 / 0.8);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-gray-500\\/10 {
  background-color: rgb(158 158 158 / 0.1);
}
.bg-gray-500\\/20 {
  background-color: rgb(158 158 158 / 0.2);
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-gray-900\\/50 {
  background-color: rgb(33 33 33 / 0.5);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(200 230 201 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-green-500\\/10 {
  background-color: rgb(76 175 80 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(76 175 80 / 0.2);
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity));
}
.bg-indigo-50\\/60 {
  background-color: rgb(232 234 246 / 0.6);
}
.bg-indigo-50\\/80 {
  background-color: rgb(232 234 246 / 0.8);
}
.bg-indigo-50\\/90 {
  background-color: rgb(232 234 246 / 0.9);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.bg-indigo-500\\/10 {
  background-color: rgb(63 81 181 / 0.1);
}
.bg-indigo-500\\/20 {
  background-color: rgb(63 81 181 / 0.2);
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(57 73 171 / var(--tw-bg-opacity));
}
.bg-indigo-600\\/90 {
  background-color: rgb(57 73 171 / 0.9);
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(48 63 159 / var(--tw-bg-opacity));
}
.bg-indigo-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(40 53 147 / var(--tw-bg-opacity));
}
.bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 126 / var(--tw-bg-opacity));
}
.bg-light-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.bg-light-blue-500\\/10 {
  background-color: rgb(3 169 244 / 0.1);
}
.bg-light-blue-500\\/20 {
  background-color: rgb(3 169 244 / 0.2);
}
.bg-light-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.bg-light-green-500\\/10 {
  background-color: rgb(139 195 74 / 0.1);
}
.bg-light-green-500\\/20 {
  background-color: rgb(139 195 74 / 0.2);
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.bg-lime-500\\/10 {
  background-color: rgb(205 220 57 / 0.1);
}
.bg-lime-500\\/20 {
  background-color: rgb(205 220 57 / 0.2);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 224 178 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10 {
  background-color: rgb(255 152 0 / 0.1);
}
.bg-orange-500\\/20 {
  background-color: rgb(255 152 0 / 0.2);
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.bg-pink-500\\/10 {
  background-color: rgb(233 30 99 / 0.1);
}
.bg-pink-500\\/20 {
  background-color: rgb(233 30 99 / 0.2);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 190 231 / var(--tw-bg-opacity));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.bg-purple-500\\/10 {
  background-color: rgb(156 39 176 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(156 39 176 / 0.2);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 205 210 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 238 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-red-500\\/10 {
  background-color: rgb(244 67 54 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(244 67 54 / 0.2);
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 241 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.bg-teal-500\\/10 {
  background-color: rgb(0 150 136 / 0.1);
}
.bg-teal-500\\/20 {
  background-color: rgb(0 150 136 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 196 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.bg-yellow-500\\/10 {
  background-color: rgb(255 235 59 / 0.1);
}
.bg-yellow-500\\/20 {
  background-color: rgb(255 235 59 / 0.2);
}
.bg-yellow-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 192 45 / var(--tw-bg-opacity));
}
.bg-opacity-0 {
  --tw-bg-opacity: 0;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-amber-50 {
  --tw-gradient-from: #fff8e1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 248 225 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600 {
  --tw-gradient-from: #ffb300 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 179 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/30 {
  --tw-gradient-from: rgb(0 0 0 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #1e88e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 136 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-gray-600 {
  --tw-gradient-from: #546e7a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(84 110 122 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brown-600 {
  --tw-gradient-from: #6d4c41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 76 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600 {
  --tw-gradient-from: #00acc1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 172 193 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-orange-600 {
  --tw-gradient-from: #f4511e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 81 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-purple-600 {
  --tw-gradient-from: #5e35b1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 53 177 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600 {
  --tw-gradient-from: #757575 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(117 117 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #212121 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 33 33 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #43a047 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 160 71 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #e8eaf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 234 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #3f51b5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(63 81 181 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #3949ab var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(57 73 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900 {
  --tw-gradient-from: #1a237e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 35 126 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-blue-600 {
  --tw-gradient-from: #039be5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 155 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-green-600 {
  --tw-gradient-from: #7cb342 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 179 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-600 {
  --tw-gradient-from: #c0ca33 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 202 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #fb8c00 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 140 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #d81b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 27 96 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #8e24aa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(142 36 170 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600 {
  --tw-gradient-from: #e53935 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 57 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #00897b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 137 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #ffffff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600 {
  --tw-gradient-from: #fdd835 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 216 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/0 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ffffff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-400 {
  --tw-gradient-to: #ffca28 var(--tw-gradient-to-position);
}
.to-black\\/0 {
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
}
.to-blue-400 {
  --tw-gradient-to: #42a5f5 var(--tw-gradient-to-position);
}
.to-blue-gray-400 {
  --tw-gradient-to: #78909c var(--tw-gradient-to-position);
}
.to-brown-400 {
  --tw-gradient-to: #8d6e63 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #26c6da var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #00bcd4 var(--tw-gradient-to-position);
}
.to-deep-orange-400 {
  --tw-gradient-to: #ff7043 var(--tw-gradient-to-position);
}
.to-deep-purple-400 {
  --tw-gradient-to: #7e57c2 var(--tw-gradient-to-position);
}
.to-gray-400 {
  --tw-gradient-to: #bdbdbd var(--tw-gradient-to-position);
}
.to-gray-800 {
  --tw-gradient-to: #424242 var(--tw-gradient-to-position);
}
.to-green-400 {
  --tw-gradient-to: #66bb6a var(--tw-gradient-to-position);
}
.to-indigo-400 {
  --tw-gradient-to: #5c6bc0 var(--tw-gradient-to-position);
}
.to-indigo-50 {
  --tw-gradient-to: #e8eaf6 var(--tw-gradient-to-position);
}
.to-indigo-50\\/40 {
  --tw-gradient-to: rgb(232 234 246 / 0.4) var(--tw-gradient-to-position);
}
.to-indigo-800 {
  --tw-gradient-to: #283593 var(--tw-gradient-to-position);
}
.to-light-blue-400 {
  --tw-gradient-to: #29b6f6 var(--tw-gradient-to-position);
}
.to-light-green-400 {
  --tw-gradient-to: #9ccc65 var(--tw-gradient-to-position);
}
.to-lime-400 {
  --tw-gradient-to: #d4e157 var(--tw-gradient-to-position);
}
.to-orange-400 {
  --tw-gradient-to: #ffa726 var(--tw-gradient-to-position);
}
.to-pink-400 {
  --tw-gradient-to: #ec407a var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #ab47bc var(--tw-gradient-to-position);
}
.to-red-400 {
  --tw-gradient-to: #ef5350 var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #26a69a var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.to-yellow-400 {
  --tw-gradient-to: #ffee58 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-text {
  background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-gray-50 {
  fill: #fafafa;
}
.fill-indigo-600 {
  fill: #3949ab;
}
.stroke-gray-200 {
  stroke: #eeeeee;
}
.stroke-\\[1px\\] {
  stroke-width: 1px;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pr-7 {
  padding-right: 1.75rem !important;
}
.\\!pr-9 {
  padding-right: 2.25rem !important;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pe-20 {
  padding-inline-end: 5rem;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.ps-12 {
  padding-inline-start: 3rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.ps-8 {
  padding-inline-start: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[9px\\] {
  padding-top: 9px;
}
.pt-px {
  padding-top: 1px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-sans {
  font-family: Roboto, sans-serif;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.\\!leading-tight {
  line-height: 1.25 !important;
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[3\\.75\\] {
  line-height: 3.75;
}
.leading-\\[4\\.1\\] {
  line-height: 4.1;
}
.leading-\\[4\\.25\\] {
  line-height: 4.25;
}
.leading-\\[4\\.875\\] {
  line-height: 4.875;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-indigo-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(48 63 159 / var(--tw-text-opacity)) !important;
}
.\\!text-indigo-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(40 53 147 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#2AC465\\] {
  --tw-text-opacity: 1;
  color: rgb(42 196 101 / var(--tw-text-opacity));
}
.text-\\[\\#334155\\] {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(255 202 40 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(255 179 0 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(255 143 0 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(187 222 251 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(30 136 229 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(21 101 192 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(13 71 161 / var(--tw-text-opacity));
}
.text-blue-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(207 216 220 / var(--tw-text-opacity));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.text-blue-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity));
}
.text-blue-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(55 71 79 / var(--tw-text-opacity));
}
.text-blue-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.text-brown-700 {
  --tw-text-opacity: 1;
  color: rgb(93 64 55 / var(--tw-text-opacity));
}
.text-brown-900 {
  --tw-text-opacity: 1;
  color: rgb(62 39 35 / var(--tw-text-opacity));
}
.text-current {
  color: currentColor;
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}
.text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.text-deep-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(230 74 25 / var(--tw-text-opacity));
}
.text-deep-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity));
}
.text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.text-deep-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity));
}
.text-deep-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(49 27 146 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(238 238 238 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-green-100 {
  --tw-text-opacity: 1;
  color: rgb(200 230 201 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(46 125 50 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(27 94 32 / var(--tw-text-opacity));
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(197 202 233 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(57 73 171 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(40 53 147 / var(--tw-text-opacity));
}
.text-indigo-800\\/80 {
  color: rgb(40 53 147 / 0.8);
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(26 35 126 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.text-light-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity));
}
.text-light-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(1 87 155 / var(--tw-text-opacity));
}
.text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.text-light-green-700 {
  --tw-text-opacity: 1;
  color: rgb(104 159 56 / var(--tw-text-opacity));
}
.text-light-green-900 {
  --tw-text-opacity: 1;
  color: rgb(51 105 30 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}
.text-orange-100 {
  --tw-text-opacity: 1;
  color: rgb(255 224 178 / var(--tw-text-opacity));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(255 167 38 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(230 81 0 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(136 14 79 / var(--tw-text-opacity));
}
.text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(225 190 231 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(74 20 140 / var(--tw-text-opacity));
}
.text-red-100 {
  --tw-text-opacity: 1;
  color: rgb(255 205 210 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(198 40 40 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(183 28 28 / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(0 77 64 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-100 {
  --tw-text-opacity: 1;
  color: rgb(255 249 196 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(249 168 37 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(245 127 23 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-\\[0\\.45\\] {
  opacity: 0.45;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20 {
  --tw-shadow-color: rgb(255 193 7 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/40 {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20 {
  --tw-shadow-color: rgb(33 150 243 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/40 {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500 {
  --tw-shadow-color: #607d8b;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/10 {
  --tw-shadow-color: rgb(96 125 139 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/20 {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/40 {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-900\\/10 {
  --tw-shadow-color: rgb(38 50 56 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/20 {
  --tw-shadow-color: rgb(121 85 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/40 {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(0 188 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/40 {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/20 {
  --tw-shadow-color: rgb(255 87 34 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/40 {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/20 {
  --tw-shadow-color: rgb(103 58 183 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/40 {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-500\\/20 {
  --tw-shadow-color: rgb(158 158 158 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-500\\/40 {
  --tw-shadow-color: rgb(158 158 158 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/10 {
  --tw-shadow-color: rgb(33 33 33 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/20 {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20 {
  --tw-shadow-color: rgb(76 175 80 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/40 {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200\\/60 {
  --tw-shadow-color: rgb(159 168 218 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20 {
  --tw-shadow-color: rgb(63 81 181 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/40 {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-900\\/10 {
  --tw-shadow-color: rgb(26 35 126 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/20 {
  --tw-shadow-color: rgb(3 169 244 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/40 {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/20 {
  --tw-shadow-color: rgb(139 195 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/40 {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/20 {
  --tw-shadow-color: rgb(205 220 57 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/40 {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(255 152 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/40 {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20 {
  --tw-shadow-color: rgb(233 30 99 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/40 {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20 {
  --tw-shadow-color: rgb(156 39 176 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/40 {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20 {
  --tw-shadow-color: rgb(244 67 54 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/40 {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20 {
  --tw-shadow-color: rgb(0 150 136 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/40 {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-900\\/10 {
  --tw-shadow-color: rgb(0 77 64 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/20 {
  --tw-shadow-color: rgb(255 235 59 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/40 {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 224 224 / var(--tw-ring-opacity));
}
.ring-indigo-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 202 233 / var(--tw-ring-opacity));
}
.ring-teal-500\\/20 {
  --tw-ring-color: rgb(0 150 136 / 0.2);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-none {
  --tw-backdrop-blur:  ;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200 {
  --tw-backdrop-saturate: saturate(2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.content-\\[\\'\\'\\] {
  --tw-content: '';
  content: var(--tw-content);
}
.\\[-webkit-appearance\\:none\\] {
  -webkit-appearance: none;
}
.\\[mask-image\\:radial-gradient\\(64rem_64rem_at_top\\2c white\\2c transparent\\)\\] {
  mask-image: radial-gradient(64rem 64rem at top,white,transparent);
}
.\\[mask-image\\:radial-gradient\\(closest-side\\2c white\\2c transparent\\)\\] {
  mask-image: radial-gradient(closest-side,white,transparent);
}
.\\[mask-image\\:radial-gradient\\(transparent\\2c white\\)\\] {
  mask-image: radial-gradient(transparent,white);
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* The Courses page provides its own keyboard-accessible clear button. */
.course-search-input::-webkit-search-cancel-button {
  appearance: none;
  -webkit-appearance: none;
}

.course-search-input::-ms-clear {
  display: none;
}

/* Changes Added By HJ */
@font-face {
  font-family: "Fira Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Bahij Helvetica Neue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* English */
:lang(en) {
  font-family: "Fira Sans", sans-serif;
}

/* Dari (fa) and Pashto (ps) */
:lang(fa),
:lang(ps) {
  font-family: "Bahij Helvetica Neue", sans-serif;
}

/* react-slick custom arrows */
.slick-arrow-custom {
  position: absolute;
  top: 140px; /* BELOW header + beta bar */
  z-index: 30; /* LOWER than navbar (z-60) */
  background-color: #334780;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.slick-arrow-custom:hover {
  transform: scale(1.1);
  background-color: #24335f;
}

.arrow-right {
  right: -18px;
}

.arrow-left {
  left: -18px;
}

/* Hide arrows on mobile */
@media (max-width: 768px) {
  .slick-arrow-custom {
    display: none;
  }
}
.file\\:mr-3::file-selector-button {
  margin-right: 0.75rem;
}
.file\\:mr-4::file-selector-button {
  margin-right: 1rem;
}
.file\\:rounded-md::file-selector-button {
  border-radius: 0.375rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-indigo-50::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity));
}
.file\\:px-3::file-selector-button {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:px-4::file-selector-button {
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-1\\.5::file-selector-button {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.file\\:py-2::file-selector-button {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:text-xs::file-selector-button {
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}
.file\\:text-indigo-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:left-2\\/4::before {
  content: var(--tw-content);
  left: 50%;
}
.before\\:top-2\\/4::before {
  content: var(--tw-content);
  top: 50%;
}
.before\\:mr-1::before {
  content: var(--tw-content);
  margin-right: 0.25rem;
}
.before\\:mt-\\[6\\.5px\\]::before {
  content: var(--tw-content);
  margin-top: 6.5px;
}
.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}
.before\\:block::before {
  content: var(--tw-content);
  display: block;
}
.before\\:h-1\\.5::before {
  content: var(--tw-content);
  height: 0.375rem;
}
.before\\:h-10::before {
  content: var(--tw-content);
  height: 2.5rem;
}
.before\\:h-12::before {
  content: var(--tw-content);
  height: 3rem;
}
.before\\:w-10::before {
  content: var(--tw-content);
  width: 2.5rem;
}
.before\\:w-12::before {
  content: var(--tw-content);
  width: 3rem;
}
.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}
.before\\:-translate-x-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:-translate-y-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:rounded-tl-md::before {
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
}
.before\\:border-l::before {
  content: var(--tw-content);
  border-left-width: 1px;
}
.before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}
.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}
.before\\:\\!border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}
.before\\:border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.before\\:border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.before\\:border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.before\\:border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.before\\:border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.before\\:border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.before\\:border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.before\\:border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.before\\:border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.before\\:border-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.before\\:border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.before\\:border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.before\\:border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.before\\:border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.before\\:border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.before\\:border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.before\\:border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.before\\:border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}
.before\\:border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.before\\:border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.before\\:border-l-transparent::before {
  content: var(--tw-content);
  border-left-color: transparent;
}
.before\\:border-t-transparent::before {
  content: var(--tw-content);
  border-top-color: transparent;
}
.before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.before\\:bg-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}
.before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:pointer-events-none::after {
  content: var(--tw-content);
  pointer-events: none;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:-bottom-0::after {
  content: var(--tw-content);
  bottom: -0px;
}
.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}
.after\\:-bottom-1\\.5::after {
  content: var(--tw-content);
  bottom: -0.375rem;
}
.after\\:-bottom-2\\.5::after {
  content: var(--tw-content);
  bottom: -0.625rem;
}
.after\\:ml-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}
.after\\:mt-\\[6\\.5px\\]::after {
  content: var(--tw-content);
  margin-top: 6.5px;
}
.after\\:box-border::after {
  content: var(--tw-content);
  box-sizing: border-box;
}
.after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:h-1\\.5::after {
  content: var(--tw-content);
  height: 0.375rem;
}
.after\\:w-2\\.5::after {
  content: var(--tw-content);
  width: 0.625rem;
}
.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:flex-grow::after {
  content: var(--tw-content);
  flex-grow: 1;
}
.after\\:scale-x-0::after {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-tr-md::after {
  content: var(--tw-content);
  border-top-right-radius: 0.375rem;
}
.after\\:border-b-2::after {
  content: var(--tw-content);
  border-bottom-width: 2px;
}
.after\\:border-r::after {
  content: var(--tw-content);
  border-right-width: 1px;
}
.after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}
.after\\:border-t::after {
  content: var(--tw-content);
  border-top-width: 1px;
}
.after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}
.after\\:\\!border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}
.after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-50::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.after\\:border-r-transparent::after {
  content: var(--tw-content);
  border-right-color: transparent;
}
.after\\:border-t-transparent::after {
  content: var(--tw-content);
  border-top-color: transparent;
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:duration-300::after {
  content: var(--tw-content);
  transition-duration: 300ms;
}
.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.even\\:bg-gray-50\\/50:nth-child(even) {
  background-color: rgb(250 250 250 / 0.5);
}
.target\\:border-indigo-500:target {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.target\\:ring-2:target {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.target\\:ring-indigo-300:target {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(121 134 203 / var(--tw-ring-opacity));
}
.checked\\:border-amber-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.checked\\:border-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.checked\\:border-blue-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.checked\\:border-brown-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.checked\\:border-cyan-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.checked\\:border-deep-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.checked\\:border-deep-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.checked\\:border-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.checked\\:border-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.checked\\:border-indigo-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.checked\\:border-light-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.checked\\:border-light-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.checked\\:border-lime-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.checked\\:border-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.checked\\:border-pink-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.checked\\:border-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.checked\\:border-red-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.checked\\:border-teal-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.checked\\:border-yellow-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.checked\\:bg-amber-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.checked\\:bg-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.checked\\:bg-blue-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.checked\\:bg-brown-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.checked\\:bg-cyan-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.checked\\:bg-deep-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.checked\\:bg-deep-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.checked\\:bg-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.checked\\:bg-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.checked\\:bg-indigo-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.checked\\:bg-indigo-900:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 126 / var(--tw-bg-opacity));
}
.checked\\:bg-light-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.checked\\:bg-light-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.checked\\:bg-lime-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.checked\\:bg-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.checked\\:bg-pink-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.checked\\:bg-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.checked\\:bg-teal-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.checked\\:bg-yellow-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-amber-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-blue-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-brown-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-cyan-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-deep-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-deep-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-indigo-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-indigo-900:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 126 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-light-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-light-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-lime-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-pink-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-red-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-teal-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-yellow-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.placeholder-shown\\:border:placeholder-shown {
  border-width: 1px;
}
.placeholder-shown\\:border-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-indigo-500:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 81 181 / var(--tw-ring-opacity));
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-100:hover {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:rounded-md:hover {
  border-radius: 0.375rem;
}
.hover\\:\\!border-indigo-500:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}
.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.hover\\:border-gray-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(97 97 97 / var(--tw-border-opacity));
}
.hover\\:border-indigo-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(159 168 218 / var(--tw-border-opacity));
}
.hover\\:border-indigo-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(121 134 203 / var(--tw-border-opacity));
}
.hover\\:border-indigo-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 154 154 / var(--tw-border-opacity));
}
.hover\\:\\!bg-indigo-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!bg-indigo-800:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(40 53 147 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!bg-red-800:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(198 40 40 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-\\[\\#20b959\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(32 185 89 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#24335f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 51 95 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#2AC465\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(42 196 101 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-500\\/10:hover {
  background-color: rgb(255 193 7 / 0.1);
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 253 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-50\\/70:hover {
  background-color: rgb(227 242 253 / 0.7);
}
.hover\\:bg-blue-500\\/10:hover {
  background-color: rgb(33 150 243 / 0.1);
}
.hover\\:bg-blue-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-gray-500\\/10:hover {
  background-color: rgb(96 125 139 / 0.1);
}
.hover\\:bg-brown-500\\/10:hover {
  background-color: rgb(121 85 72 / 0.1);
}
.hover\\:bg-cyan-500\\/10:hover {
  background-color: rgb(0 188 212 / 0.1);
}
.hover\\:bg-deep-orange-500\\/10:hover {
  background-color: rgb(255 87 34 / 0.1);
}
.hover\\:bg-deep-purple-500\\/10:hover {
  background-color: rgb(103 58 183 / 0.1);
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-500\\/10:hover {
  background-color: rgb(158 158 158 / 0.1);
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(97 97 97 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}
.hover\\:bg-green-500\\/10:hover {
  background-color: rgb(76 175 80 / 0.1);
}
.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-500\\/10:hover {
  background-color: rgb(63 81 181 / 0.1);
}
.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(57 73 171 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(48 63 159 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(40 53 147 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 126 / var(--tw-bg-opacity));
}
.hover\\:bg-light-blue-500\\/10:hover {
  background-color: rgb(3 169 244 / 0.1);
}
.hover\\:bg-light-green-500\\/10:hover {
  background-color: rgb(139 195 74 / 0.1);
}
.hover\\:bg-lime-500\\/10:hover {
  background-color: rgb(205 220 57 / 0.1);
}
.hover\\:bg-orange-500\\/10:hover {
  background-color: rgb(255 152 0 / 0.1);
}
.hover\\:bg-pink-500\\/10:hover {
  background-color: rgb(233 30 99 / 0.1);
}
.hover\\:bg-purple-500\\/10:hover {
  background-color: rgb(156 39 176 / 0.1);
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 238 / var(--tw-bg-opacity));
}
.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(244 67 54 / 0.1);
}
.hover\\:bg-teal-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-500\\/10:hover {
  background-color: rgb(0 150 136 / 0.1);
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-yellow-500\\/10:hover {
  background-color: rgb(255 235 59 / 0.1);
}
.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-blue-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.hover\\:text-blue-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(238 238 238 / var(--tw-text-opacity));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(57 73 171 / var(--tw-text-opacity));
}
.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(40 53 147 / var(--tw-text-opacity));
}
.hover\\:text-light-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-75:hover {
  opacity: 0.75;
}
.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-amber-500\\/40:hover {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-500\\/40:hover {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-gray-500:hover {
  --tw-shadow-color: #607d8b;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-gray-500\\/20:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-gray-500\\/40:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-brown-500\\/40:hover {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-cyan-500\\/40:hover {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-deep-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-deep-purple-500\\/40:hover {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-gray-500\\/40:hover {
  --tw-shadow-color: rgb(158 158 158 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-gray-900\\/20:hover {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-green-500\\/40:hover {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-400\\/40:hover {
  --tw-shadow-color: rgb(92 107 192 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-500\\/40:hover {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-900\\/20:hover {
  --tw-shadow-color: rgb(26 35 126 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-light-blue-500\\/40:hover {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-light-green-500\\/40:hover {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-lime-500\\/40:hover {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-pink-500\\/40:hover {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-purple-500\\/40:hover {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-red-500\\/40:hover {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-teal-500\\/40:hover {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-yellow-500\\/40:hover {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:file\\:bg-indigo-100::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity));
}
.hover\\:before\\:opacity-10:hover::before {
  content: var(--tw-content);
  opacity: 0.1;
}
.focus\\:scale-110:focus {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.focus\\:border-2:focus {
  border-width: 2px;
}
.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.focus\\:border-blue-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.focus\\:border-brown-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.focus\\:border-deep-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.focus\\:border-deep-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.focus\\:border-gray-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.focus\\:border-indigo-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(92 107 192 / var(--tw-border-opacity));
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.focus\\:border-indigo-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-border-opacity));
}
.focus\\:border-light-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.focus\\:border-light-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.focus\\:border-lime-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.focus\\:border-pink-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}
.focus\\:bg-blue-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.focus\\:bg-transparent:focus {
  background-color: transparent;
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.focus\\:bg-opacity-80:focus {
  --tw-bg-opacity: 0.8;
}
.focus\\:text-blue-gray-500:focus {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.focus\\:text-blue-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.focus\\:opacity-\\[0\\.85\\]:focus {
  opacity: 0.85;
}
.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline-0:focus {
  outline-width: 0px;
}
.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}
.focus\\:ring-\\[\\#25D366\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 211 102 / var(--tw-ring-opacity));
}
.focus\\:ring-\\[\\#334780\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 71 128 / var(--tw-ring-opacity));
}
.focus\\:ring-amber-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 224 130 / var(--tw-ring-opacity));
}
.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 202 249 / var(--tw-ring-opacity));
}
.focus\\:ring-blue-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(176 190 197 / var(--tw-ring-opacity));
}
.focus\\:ring-brown-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 170 164 / var(--tw-ring-opacity));
}
.focus\\:ring-cyan-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 222 234 / var(--tw-ring-opacity));
}
.focus\\:ring-deep-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 171 145 / var(--tw-ring-opacity));
}
.focus\\:ring-deep-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(179 157 219 / var(--tw-ring-opacity));
}
.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 238 238 / var(--tw-ring-opacity));
}
.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 214 167 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 202 233 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 168 218 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(121 134 203 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 81 181 / var(--tw-ring-opacity));
}
.focus\\:ring-light-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 212 250 / var(--tw-ring-opacity));
}
.focus\\:ring-light-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 225 165 / var(--tw-ring-opacity));
}
.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 238 156 / var(--tw-ring-opacity));
}
.focus\\:ring-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 204 128 / var(--tw-ring-opacity));
}
.focus\\:ring-pink-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 143 177 / var(--tw-ring-opacity));
}
.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(206 147 216 / var(--tw-ring-opacity));
}
.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 154 154 / var(--tw-ring-opacity));
}
.focus\\:ring-teal-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 203 196 / var(--tw-ring-opacity));
}
.focus\\:ring-teal-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 137 123 / var(--tw-ring-opacity));
}
.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.focus\\:ring-yellow-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 245 157 / var(--tw-ring-opacity));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}
.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:outline-indigo-600:focus-visible {
  outline-color: #3949ab;
}
.focus-visible\\:outline-indigo-700:focus-visible {
  outline-color: #303f9f;
}
.focus-visible\\:outline-red-700:focus-visible {
  outline-color: #d32f2f;
}
.focus-visible\\:outline-teal-600:focus-visible {
  outline-color: #00897b;
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-indigo-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 81 181 / var(--tw-ring-opacity));
}
.focus-visible\\:ring-indigo-600:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(57 73 171 / var(--tw-ring-opacity));
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.active\\:scale-100:active {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:\\!bg-indigo-100:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity)) !important;
}
.active\\:\\!bg-indigo-900:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(26 35 126 / var(--tw-bg-opacity)) !important;
}
.active\\:\\!bg-red-900:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(183 28 28 / var(--tw-bg-opacity)) !important;
}
.active\\:bg-amber-500\\/30:active {
  background-color: rgb(255 193 7 / 0.3);
}
.active\\:bg-blue-500\\/30:active {
  background-color: rgb(33 150 243 / 0.3);
}
.active\\:bg-blue-gray-50:active {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.active\\:bg-blue-gray-500\\/30:active {
  background-color: rgb(96 125 139 / 0.3);
}
.active\\:bg-brown-500\\/30:active {
  background-color: rgb(121 85 72 / 0.3);
}
.active\\:bg-cyan-500\\/30:active {
  background-color: rgb(0 188 212 / 0.3);
}
.active\\:bg-deep-orange-500\\/30:active {
  background-color: rgb(255 87 34 / 0.3);
}
.active\\:bg-deep-purple-500\\/30:active {
  background-color: rgb(103 58 183 / 0.3);
}
.active\\:bg-gray-500\\/30:active {
  background-color: rgb(158 158 158 / 0.3);
}
.active\\:bg-green-500\\/30:active {
  background-color: rgb(76 175 80 / 0.3);
}
.active\\:bg-indigo-100:active {
  --tw-bg-opacity: 1;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity));
}
.active\\:bg-indigo-500\\/30:active {
  background-color: rgb(63 81 181 / 0.3);
}
.active\\:bg-light-blue-500\\/30:active {
  background-color: rgb(3 169 244 / 0.3);
}
.active\\:bg-light-green-500\\/30:active {
  background-color: rgb(139 195 74 / 0.3);
}
.active\\:bg-lime-500\\/30:active {
  background-color: rgb(205 220 57 / 0.3);
}
.active\\:bg-orange-500\\/30:active {
  background-color: rgb(255 152 0 / 0.3);
}
.active\\:bg-pink-500\\/30:active {
  background-color: rgb(233 30 99 / 0.3);
}
.active\\:bg-purple-500\\/30:active {
  background-color: rgb(156 39 176 / 0.3);
}
.active\\:bg-red-100:active {
  --tw-bg-opacity: 1;
  background-color: rgb(255 205 210 / var(--tw-bg-opacity));
}
.active\\:bg-red-500\\/30:active {
  background-color: rgb(244 67 54 / 0.3);
}
.active\\:bg-teal-500\\/30:active {
  background-color: rgb(0 150 136 / 0.3);
}
.active\\:bg-transparent:active {
  background-color: transparent;
}
.active\\:bg-white\\/30:active {
  background-color: rgb(255 255 255 / 0.3);
}
.active\\:bg-yellow-500\\/30:active {
  background-color: rgb(255 235 59 / 0.3);
}
.active\\:bg-opacity-80:active {
  --tw-bg-opacity: 0.8;
}
.active\\:text-blue-gray-500:active {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.active\\:text-blue-gray-900:active {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.active\\:opacity-\\[0\\.85\\]:active {
  opacity: 0.85;
}
.active\\:shadow-none:active {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:resize-none:disabled {
  resize: none;
}
.disabled\\:border-0:disabled {
  border-width: 0px;
}
.disabled\\:border-gray-200:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.disabled\\:border-red-200:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(239 154 154 / var(--tw-border-opacity));
}
.disabled\\:\\!bg-indigo-200:disabled {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(159 168 218 / var(--tw-bg-opacity)) !important;
}
.disabled\\:\\!bg-red-200:disabled {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 154 154 / var(--tw-bg-opacity)) !important;
}
.disabled\\:bg-blue-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.disabled\\:\\!text-indigo-800:disabled {
  --tw-text-opacity: 1 !important;
  color: rgb(40 53 147 / var(--tw-text-opacity)) !important;
}
.disabled\\:\\!text-red-700:disabled {
  --tw-text-opacity: 1 !important;
  color: rgb(211 47 47 / var(--tw-text-opacity)) !important;
}
.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.disabled\\:text-red-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(229 115 115 / var(--tw-text-opacity));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:hover\\:cursor-not-allowed:hover:disabled {
  cursor: not-allowed;
}
.group:hover .group-hover\\:rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(197 202 233 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-indigo-50 {
  --tw-text-opacity: 1;
  color: rgb(232 234 246 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:ring-white\\/30 {
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.peer:checked ~ .peer-checked\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:opacity-100 {
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:before\\:bg-amber-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-brown-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-cyan-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-deep-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-deep-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-indigo-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-light-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-light-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-lime-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-pink-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-red-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-teal-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-yellow-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[3\\.75\\] {
  line-height: 3.75;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.1\\] {
  line-height: 4.1;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.25\\] {
  line-height: 4.25;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.875\\] {
  line-height: 4.875;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-tight {
  line-height: 1.25;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.peer:focus ~ .peer-focus\\:text-\\[11px\\] {
  font-size: 11px;
}
.peer:focus ~ .peer-focus\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.peer:focus ~ .peer-focus\\:leading-tight {
  line-height: 1.25;
}
.peer:focus ~ .peer-focus\\:text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}
.peer:focus ~ .peer-focus\\:before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(158 158 158 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}
.peer:focus ~ .peer-focus\\:after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(158 158 158 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.peer:disabled ~ .peer-disabled\\:text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.peer:disabled ~ .peer-disabled\\:text-transparent {
  color: transparent;
}
.peer:disabled ~ .peer-disabled\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}
.peer:disabled ~ .peer-disabled\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.peer:disabled:placeholder-shown ~ .peer-disabled\\:peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.dark\\:divide-gray-600:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(117 117 117 / var(--tw-divide-opacity));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(97 97 97 / var(--tw-border-opacity));
}
.dark\\:border-red-500\\/30:is(.dark *) {
  border-color: rgb(244 67 54 / 0.3);
}
.dark\\:bg-amber-500\\/10:is(.dark *) {
  background-color: rgb(255 193 7 / 0.1);
}
.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(97 97 97 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-800\\/80:is(.dark *) {
  background-color: rgb(66 66 66 / 0.8);
}
.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(33 33 33 / 0.4);
}
.dark\\:bg-gray-900\\/60:is(.dark *) {
  background-color: rgb(33 33 33 / 0.6);
}
.dark\\:bg-red-500\\/10:is(.dark *) {
  background-color: rgb(244 67 54 / 0.1);
}
.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 213 79 / var(--tw-text-opacity));
}
.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(238 238 238 / var(--tw-text-opacity));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 134 203 / var(--tw-text-opacity));
}
.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 115 115 / var(--tw-text-opacity));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(117 117 117 / var(--tw-bg-opacity));
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(97 97 97 / var(--tw-bg-opacity));
}
.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark\\:focus\\:ring-gray-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(117 117 117 / var(--tw-ring-opacity));
}
.dark\\:disabled\\:border-gray-800:disabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-border-opacity));
}
.dark\\:disabled\\:bg-gray-900\\/30:disabled:is(.dark *) {
  background-color: rgb(33 33 33 / 0.3);
}
.dark\\:disabled\\:text-gray-500:disabled:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
@media (min-width: 540px) {

  .sm\\:static {
    position: static;
  }

  .sm\\:inset-auto {
    inset: auto;
  }

  .sm\\:left-full {
    left: 100%;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .sm\\:-ml-80 {
    margin-left: -20rem;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-52 {
    height: 13rem;
  }

  .sm\\:h-screen {
    height: 100vh;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-5xl {
    max-width: 64rem;
  }

  .sm\\:max-w-\\[140px\\] {
    max-width: 140px;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-8 {
    padding-bottom: 2rem;
  }

  .sm\\:pr-0 {
    padding-right: 0px;
  }

  .sm\\:pr-4 {
    padding-right: 1rem;
  }

  .sm\\:pt-24 {
    padding-top: 6rem;
  }

  .sm\\:pt-4 {
    padding-top: 1rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem;
  }
}
@media (min-width: 720px) {

  .md\\:-left-4 {
    left: -1rem;
  }

  .md\\:-right-4 {
    right: -1rem;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-5\\/6 {
    width: 83.333333%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .md\\:min-w-\\[66\\.666667\\%\\] {
    min-width: 66.666667%;
  }

  .md\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .md\\:min-w-\\[83\\.333333\\%\\] {
    min-width: 83.333333%;
  }

  .md\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .md\\:max-w-\\[66\\.666667\\%\\] {
    max-width: 66.666667%;
  }

  .md\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .md\\:max-w-\\[83\\.333333\\%\\] {
    max-width: 83.333333%;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:border-l-2 {
    border-left-width: 2px;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:text-start {
    text-align: start;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 960px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:-top-28 {
    top: -7rem;
  }

  .lg\\:left-1\\/2 {
    left: 50%;
  }

  .lg\\:top-4 {
    top: 1rem;
  }

  .lg\\:top-5 {
    top: 1.25rem;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:col-start-1 {
    grid-column-start: 1;
  }

  .lg\\:col-start-2 {
    grid-column-start: 2;
  }

  .lg\\:row-start-1 {
    grid-row-start: 1;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:-mt-20 {
    margin-top: -5rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-10 {
    margin-top: 2.5rem;
  }

  .lg\\:mt-20 {
    margin-top: 5rem;
  }

  .lg\\:mt-3 {
    margin-top: 0.75rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-9 {
    height: 2.25rem;
  }

  .lg\\:h-\\[83vh\\] {
    height: 83vh;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-72 {
    width: 18rem;
  }

  .lg\\:w-9 {
    width: 2.25rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-0 {
    min-width: 0px;
  }

  .lg\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .lg\\:min-w-\\[50\\%\\] {
    min-width: 50%;
  }

  .lg\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .lg\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .lg\\:max-w-7xl {
    max-width: 80rem;
  }

  .lg\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .lg\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .lg\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .lg\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[19rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 19rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[1fr_1fr_auto\\] {
    grid-template-columns: 1fr 1fr auto;
  }

  .lg\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[230px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 230px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_19rem\\] {
    grid-template-columns: minmax(0,1fr) 19rem;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-3 {
    gap: 0.75rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-x-8 {
    column-gap: 2rem;
  }

  .lg\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .lg\\:p-3 {
    padding: 0.75rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-5 {
    padding: 1.25rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:pl-0 {
    padding-left: 0px;
  }

  .lg\\:pr-12 {
    padding-right: 3rem;
  }

  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:pt-2 {
    padding-top: 0.5rem;
  }

  .lg\\:pt-7 {
    padding-top: 1.75rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1140px) {

  .xl\\:sticky {
    position: sticky;
  }

  .xl\\:top-24 {
    top: 6rem;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:grid {
    display: grid;
  }

  .xl\\:h-fit {
    height: -moz-fit-content;
    height: fit-content;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[0\\.9fr_1\\.5fr\\] {
    grid-template-columns: 0.9fr 1.5fr;
  }

  .xl\\:grid-cols-\\[1\\.15fr_1fr\\] {
    grid-template-columns: 1.15fr 1fr;
  }

  .xl\\:grid-cols-\\[1\\.35fr_0\\.85fr\\] {
    grid-template-columns: 1.35fr 0.85fr;
  }

  .xl\\:grid-cols-\\[280px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 280px minmax(0,1fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1\\.6fr\\)_minmax\\(260px\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,1.6fr) minmax(260px,1fr);
  }

  .xl\\:gap-16 {
    gap: 4rem;
  }

  .xl\\:gap-4 {
    gap: 1rem;
  }

  .xl\\:gap-x-16 {
    column-gap: 4rem;
  }

  .xl\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
@media (min-width: 1320px) {

  .\\32xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\32xl\\:w-1\\/4 {
    width: 25%;
  }

  .\\32xl\\:w-2\\/5 {
    width: 40%;
  }

  .\\32xl\\:w-3\\/4 {
    width: 75%;
  }

  .\\32xl\\:w-3\\/5 {
    width: 60%;
  }

  .\\32xl\\:min-w-\\[25\\%\\] {
    min-width: 25%;
  }

  .\\32xl\\:min-w-\\[33\\.333333\\%\\] {
    min-width: 33.333333%;
  }

  .\\32xl\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .\\32xl\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .\\32xl\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .\\32xl\\:max-w-\\[25\\%\\] {
    max-width: 25%;
  }

  .\\32xl\\:max-w-\\[33\\.333333\\%\\] {
    max-width: 33.333333%;
  }

  .\\32xl\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .\\32xl\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .\\32xl\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }
}
.ltr\\:left-1:where([dir="ltr"], [dir="ltr"] *) {
  left: 0.25rem;
}
.ltr\\:right-0:where([dir="ltr"], [dir="ltr"] *) {
  right: 0px;
}
.ltr\\:right-10:where([dir="ltr"], [dir="ltr"] *) {
  right: 2.5rem;
}
.ltr\\:right-2:where([dir="ltr"], [dir="ltr"] *) {
  right: 0.5rem;
}
.ltr\\:right-5:where([dir="ltr"], [dir="ltr"] *) {
  right: 1.25rem;
}
.ltr\\:right-\\[5\\.5rem\\]:where([dir="ltr"], [dir="ltr"] *) {
  right: 5.5rem;
}
.ltr\\:ml-auto:where([dir="ltr"], [dir="ltr"] *) {
  margin-left: auto;
}
.ltr\\:rotate-0:where([dir="ltr"], [dir="ltr"] *) {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:justify-end:where([dir="ltr"], [dir="ltr"] *) {
  justify-content: flex-end;
}
.ltr\\:pr-10:where([dir="ltr"], [dir="ltr"] *) {
  padding-right: 2.5rem;
}
.ltr\\:text-left:where([dir="ltr"], [dir="ltr"] *) {
  text-align: left;
}
.rtl\\:left-0:where([dir="rtl"], [dir="rtl"] *) {
  left: 0px;
}
.rtl\\:left-10:where([dir="rtl"], [dir="rtl"] *) {
  left: 2.5rem;
}
.rtl\\:left-2:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.5rem;
}
.rtl\\:left-4:where([dir="rtl"], [dir="rtl"] *) {
  left: 1rem;
}
.rtl\\:left-5:where([dir="rtl"], [dir="rtl"] *) {
  left: 1.25rem;
}
.rtl\\:left-\\[5\\.5rem\\]:where([dir="rtl"], [dir="rtl"] *) {
  left: 5.5rem;
}
.rtl\\:right-1:where([dir="rtl"], [dir="rtl"] *) {
  right: 0.25rem;
}
.rtl\\:right-auto:where([dir="rtl"], [dir="rtl"] *) {
  right: auto;
}
.rtl\\:mr-auto:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: auto;
}
.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:justify-start:where([dir="rtl"], [dir="rtl"] *) {
  justify-content: flex-start;
}
.rtl\\:pl-10:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 2.5rem;
}
.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
@media (min-width: 540px) {

  .rtl\\:sm\\:ml-0:where([dir="rtl"], [dir="rtl"] *) {
    margin-left: 0px;
  }

  .rtl\\:sm\\:mr-auto:where([dir="rtl"], [dir="rtl"] *) {
    margin-right: auto;
  }
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:relative::-moz-range-thumb {
  position: relative;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:z-20::-moz-range-thumb {
  z-index: 20;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-1::-moz-range-thumb {
  margin-top: -0.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-\\[3px\\]::-moz-range-thumb {
  margin-top: -3px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-2\\.5::-moz-range-thumb {
  height: 0.625rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-3\\.5::-moz-range-thumb {
  height: 0.875rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-5::-moz-range-thumb {
  height: 1.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-2\\.5::-moz-range-thumb {
  width: 0.625rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-3\\.5::-moz-range-thumb {
  width: 0.875rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-5::-moz-range-thumb {
  width: 1.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb {
  appearance: none;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb {
  border-width: 0px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-white::-moz-range-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-2::-moz-range-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-current::-moz-range-thumb {
  --tw-ring-color: currentColor;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-moz-range-thumb {
  -webkit-appearance: none;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:h-full::-moz-range-track {
  height: 100%;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:rounded-full::-moz-range-track {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:bg-blue-gray-100::-moz-range-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:h-full::-webkit-slider-runnable-track {
  height: 100%;
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:rounded-full::-webkit-slider-runnable-track {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:bg-blue-gray-100::-webkit-slider-runnable-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:relative::-webkit-slider-thumb {
  position: relative;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:z-20::-webkit-slider-thumb {
  z-index: 20;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-1::-webkit-slider-thumb {
  margin-top: -0.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-\\[3px\\]::-webkit-slider-thumb {
  margin-top: -3px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-2\\.5::-webkit-slider-thumb {
  height: 0.625rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-3\\.5::-webkit-slider-thumb {
  height: 0.875rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5::-webkit-slider-thumb {
  height: 1.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2::-webkit-slider-thumb {
  width: 0.5rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2\\.5::-webkit-slider-thumb {
  width: 0.625rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3::-webkit-slider-thumb {
  width: 0.75rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3\\.5::-webkit-slider-thumb {
  width: 0.875rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5::-webkit-slider-thumb {
  width: 1.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-0::-webkit-slider-thumb {
  border-width: 0px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white::-webkit-slider-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-2::-webkit-slider-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-current::-webkit-slider-thumb {
  --tw-ring-color: currentColor;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
.\\[\\&_a\\]\\:text-indigo-700 a {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.\\[\\&_a\\]\\:underline a {
  text-decoration-line: underline;
}
.\\[\\&_blockquote\\]\\:my-5 blockquote {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.\\[\\&_blockquote\\]\\:rounded-2xl blockquote {
  border-radius: 1rem;
}
.\\[\\&_blockquote\\]\\:border-s-4 blockquote {
  border-inline-start-width: 4px;
}
.\\[\\&_blockquote\\]\\:border-indigo-400 blockquote {
  --tw-border-opacity: 1;
  border-color: rgb(92 107 192 / var(--tw-border-opacity));
}
.\\[\\&_blockquote\\]\\:bg-indigo-50 blockquote {
  --tw-bg-opacity: 1;
  background-color: rgb(232 234 246 / var(--tw-bg-opacity));
}
.\\[\\&_blockquote\\]\\:px-5 blockquote {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.\\[\\&_blockquote\\]\\:py-4 blockquote {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.\\[\\&_h1\\]\\:mb-4 h1 {
  margin-bottom: 1rem;
}
.\\[\\&_h1\\]\\:text-3xl h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.\\[\\&_h1\\]\\:font-bold h1 {
  font-weight: 700;
}
.\\[\\&_h1\\]\\:text-gray-900 h1 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.\\[\\&_h2\\]\\:mb-4 h2 {
  margin-bottom: 1rem;
}
.\\[\\&_h2\\]\\:mt-10 h2 {
  margin-top: 2.5rem;
}
.\\[\\&_h2\\]\\:scroll-mt-28 h2 {
  scroll-margin-top: 7rem;
}
.\\[\\&_h2\\]\\:text-2xl h2 {
  font-size: 1.5rem;
  line-height: 2rem;
}
.\\[\\&_h2\\]\\:font-semibold h2 {
  font-weight: 600;
}
.\\[\\&_h2\\]\\:text-gray-900 h2 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.\\[\\&_h3\\]\\:mb-3 h3 {
  margin-bottom: 0.75rem;
}
.\\[\\&_h3\\]\\:mt-8 h3 {
  margin-top: 2rem;
}
.\\[\\&_h3\\]\\:scroll-mt-28 h3 {
  scroll-margin-top: 7rem;
}
.\\[\\&_h3\\]\\:text-xl h3 {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.\\[\\&_h3\\]\\:font-semibold h3 {
  font-weight: 600;
}
.\\[\\&_h3\\]\\:text-gray-900 h3 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.\\[\\&_img\\]\\:my-6 img {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\[\\&_img\\]\\:max-w-full img {
  max-width: 100%;
}
.\\[\\&_img\\]\\:rounded-2xl img {
  border-radius: 1rem;
}
.\\[\\&_img\\]\\:border img {
  border-width: 1px;
}
.\\[\\&_img\\]\\:border-gray-200 img {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.\\[\\&_img\\]\\:shadow-sm img {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&_ol\\]\\:my-5 ol {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.\\[\\&_ol\\]\\:list-decimal ol {
  list-style-type: decimal;
}
.\\[\\&_ol\\]\\:pl-6 ol {
  padding-left: 1.5rem;
}
.\\[\\&_ol\\]\\:pr-6 ol {
  padding-right: 1.5rem;
}
.\\[\\&_p\\]\\:mb-4 p {
  margin-bottom: 1rem;
}
.\\[\\&_table\\]\\:my-6 table {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\[\\&_table\\]\\:w-full table {
  width: 100%;
}
.\\[\\&_table\\]\\:border-collapse table {
  border-collapse: collapse;
}
.\\[\\&_td\\]\\:border td {
  border-width: 1px;
}
.\\[\\&_td\\]\\:border-gray-200 td {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.\\[\\&_td\\]\\:p-3 td {
  padding: 0.75rem;
}
.\\[\\&_th\\]\\:border th {
  border-width: 1px;
}
.\\[\\&_th\\]\\:border-gray-200 th {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.\\[\\&_th\\]\\:bg-gray-50 th {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.\\[\\&_th\\]\\:p-3 th {
  padding: 0.75rem;
}
.\\[\\&_ul\\]\\:my-5 ul {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.\\[\\&_ul\\]\\:list-disc ul {
  list-style-type: disc;
}
.\\[\\&_ul\\]\\:pl-6 ul {
  padding-left: 1.5rem;
}
.\\[\\&_ul\\]\\:pr-6 ul {
  padding-right: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,+DAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;;EAEE,+CAA+C;AACjD;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,UAAU,EAAE,4BAA4B;EACxC,WAAW,EAAE,6BAA6B;EAC1C,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;AACF;AA9FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,qBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,qBA+FA;EA/FA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,wBA+FA;EA/FA,wDA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,4BA+FA;EA/FA,wDA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,eA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,eA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,wBA+FA;EA/FA,wDA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,8BA+FA;EA/FA,wDA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,2BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,eA+FA;EA/FA,eA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,iBA+FA;EA/FA,iBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,gDA+FA;EA/FA,6DA+FA;EA/FA;AA+FA;AA/FA;EAAA,+EA+FA;EA/FA,mGA+FA;EA/FA;AA+FA;AA/FA;EAAA,6EA+FA;EA/FA,iGA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,yCA+FA;EA/FA;AA+FA;AA/FA;EAAA,sCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,uCA+FA;EA/FA;AA+FA;AA/FA;EAAA,wCA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,iBA+FA;EA/FA,iBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iCA+FA;EA/FA,+CA+FA;EA/FA;AA+FA;AA/FA;EAAA,8BA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,8BA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,eA+FA;EA/FA,eA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iCA+FA;EA/FA,+CA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,6BA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,+BA+FA;EA/FA;AA+FA;AA/FA;EAAA,+BA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iCA+FA;EA/FA,+CA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,eA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,iCA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,0BA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,oBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,qBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,oBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,oBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;AAAA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,qBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;AAAA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,gBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,sBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,qBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,oBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,qBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,iBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,mBA+FA;IA/FA;EA+FA;;EA/FA;IAAA,kBA+FA;IA/FA;EA+FA;AAAA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,wBA+FA;IA/FA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA,eA+FA;IA/FA;EA+FA;AAAA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;AAAA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;;EAAA;IAAA;EA+FA;;EA/FA;IAAA;EA+FA;AAAA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,2GA+FA;EA/FA,yGA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA,qBA+FA;EA/FA;AA+FA;AA/FA;EAAA,iBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,iBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,oBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,0CA+FA;EA/FA,uDA+FA;EA/FA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,sBA+FA;EA/FA;AA+FA;AA/FA;EAAA,kBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA,mBA+FA;EA/FA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA;AA/FA;EAAA;AA+FA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* The Courses page provides its own keyboard-accessible clear button. */\n.course-search-input::-webkit-search-cancel-button {\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.course-search-input::-ms-clear {\n  display: none;\n}\n\n/* Changes Added By HJ */\n@font-face {\n  font-family: \"Fira Sans\";\n  src: url(\"./assets/Fonts/Fira_Sans/FiraSans-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Bahij Helvetica Neue\";\n  src: url(\"./assets/Fonts/Bahij Helvetica/Bahij\\ Helvetica\\ Neue-Roman.ttf\")\n    format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* English */\n:lang(en) {\n  font-family: \"Fira Sans\", sans-serif;\n}\n\n/* Dari (fa) and Pashto (ps) */\n:lang(fa),\n:lang(ps) {\n  font-family: \"Bahij Helvetica Neue\", sans-serif;\n}\n\n/* react-slick custom arrows */\n.slick-arrow-custom {\n  position: absolute;\n  top: 140px; /* BELOW header + beta bar */\n  z-index: 30; /* LOWER than navbar (z-60) */\n  background-color: #334780;\n  color: #fff;\n  width: 36px;\n  height: 36px;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.slick-arrow-custom:hover {\n  transform: scale(1.1);\n  background-color: #24335f;\n}\n\n.arrow-right {\n  right: -18px;\n}\n\n.arrow-left {\n  left: -18px;\n}\n\n/* Hide arrows on mobile */\n@media (max-width: 768px) {\n  .slick-arrow-custom {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
